import React from 'react';
import { useState, useEffect, useRef } from 'react';
import { post, get, isEmptyObject } from "jquery";
import InfoTable from '../../components/common/infotable';
import Utils from '../../helpers/utils';
import { DateTimeFormat } from '../../helpers/const';

const WLT0001_Master = (props) => {

    const [infoRecordsList, setInfoRecordsList] = useState([]);
    const [ninushi, setNinushiList] = useState([]);
    const [sydate, setSysdate] = useState(null);

    useEffect(() => {
        sessionStorage.clear();
        get({ url: props.getNinushiDtlUrl }, json => {
            let ninushi = JSON.parse(json);
            setNinushiList(ninushi);
        });

        get({ url: props.getInfoRecordsUrl, cache: false }, json => {
            let info = JSON.parse(json);
            setInfoRecordsList(info);
        });
        get({ url: props.getSysdateDtlUrl,data:{test:new Date()} }, json => {
            let info = JSON.parse(json);
            setSysdate(info);
            // if(info != null && info.StopFlg == true){
            //     $("#ninushi-disabled-msg").show();
            // }
        });

    }, []);

    function renderLogo() {
        if (!Utils.isNullOrEmpty(ninushi.LogoFileName)) {
            document.getElementById('placeholder').src = ninushi.LogoFileName;
        }
    }

    function renderNinushiMessage() {
        if (ninushi.ToppageMessage != null) {
            return (
                <div className="ninushi-dtl" style={{lineBreak:"anywhere", whiteSpace:"pre-line"}}>
                    <p id="para-rdx">{ninushi.ToppageMessage}</p>
                </div>
            )
        }
    }

    function renderInfomation() {
        return (
            <div className="widget widget-sparkline">
                <div className="widget-header">
                    <h3 id="para-blk-mnr">お知らせ・新着情報</h3>
                </div>
                <div className="widget-content">
                    <InfoTable data={infoRecordsList} />
                </div>
            </div>
        );
    }

    return (
        <div>
            {renderLogo()}
            {renderNinushiMessage()}
            {renderInfomation()}
        </div>
    );
}

export default WLT0001_Master;


// WEBPACK FOOTER //
// ./view/WLT0001/WLT0001-master.jsx